import { c as _c } from "react/compiler-runtime";
import { Heading } from '@petsmart-ui/sparky';
import type { PromoOfferTableProps } from '@/types';
import { BaseTable } from '../../BaseTable/BaseTable';
import { tableConfig } from './tableConfig';
export function PromoOfferTable(t0) {
  const $ = _c(4);
  const {
    isJobsLoading,
    promoJobs
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Heading tagName="h4">Your Promotions Offer Table</Heading>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isJobsLoading || $[2] !== promoJobs) {
    t2 = <>{t1}<div className="homepage-table-wrapper"><BaseTable data={promoJobs} config={tableConfig} loading={isJobsLoading} caption="Promotions Offer Assignment Table" loadingContent="Loading promo jobs..." emptyContent="No promotions available." rowKey={_temp} /></div></>;
    $[1] = isJobsLoading;
    $[2] = promoJobs;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(job) {
  return job.jobId;
}